<template>
  <div class="flex flex-col items-center">
    <transition name="fade">
      <iframe
        width="620"
        height="515"
        src="https://youtube.com/embed/XE4ZjapRBCQ"
        frameborder="0"
        allowfullscreen
        v-if="youtube"
      ></iframe>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      youtube: false
    };
  },
  created() {
    setTimeout(() => {
      this.youtube = true;
    }, 3000);
  }
};
</script>

<style lang="stylus" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 2s;
}
</style>